<template>
  <div>
    <div class="trends">
      <!-- <div class="top">
        <div class="auto_1280">
          <div class="swiper-container">
            <div class="swiper-wrapper ul1">
              <div class="swiper-slide" v-for="( item, index ) in topList" :key="index" @click="goDetail(item)">
                <div class="pic" :style="'background-image: url(' + item.coverImg + ')'">
                  <span class="dot">{{item.tag}}</span>
                </div>
                <div class="content">
                  <div class="title dot2">{{item.title}}</div>
                  <div class="intro dot2">{{item.intro}}</div>
                  <div class="under clearfix">
                    <div class="date">{{item.createTime | format}}</div>
                    <div class="more" v-if="lan === 0">了解更多</div>
                    <div class="more" v-else-if="lan === 1">Learn More</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div> -->
      <div class="auto_1280">
        <ul class="ul ul2">
          <li v-for="( item, index ) in trendsList" :key="index" @click="goDetail(item)">
            <div class="pic"><img :src="item.coverImg" alt=""></div>
            <div class="content">
              <div class="title dot">{{item.title}}</div>
              <div class="intro dot2">{{item.intro}}</div>
              <div class="under clearfix">
                <!-- <div class="date">{{item.createTime | format}}</div> -->
                <div class="more" v-if="lan === 0">了解更多</div>
                <div class="more" v-else-if="lan === 1">Learn More</div>
              </div>
            </div>
          </li>
        </ul>
        <div class="pager" v-if="trendsList.length > 0">
          <span class="p_page">
            <a @click="pageIndex = ( pageIndex == 1 ? 1 : pageIndex - 1 );" class="a_prev" :class="{disable_prev: pageIndex == 1}"></a>
            <em class="num">
              <template v-for="( num, index ) in pageList">
                <a @click="pageIndex = num;" :key="index" :class="[ num == pageIndex ? 'a_cur' : '' ]">{{num}}</a>
              </template>
            </em>
            <a @click="pageIndex = ( pageIndex == maxPageIndex ? maxPageIndex : pageIndex + 1 );" class="a_next" :class="{disable_next: pageIndex == maxPageIndex}"></a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'Trends',
  filters: {
    format (value) {
      const date = new Date(value)
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const sdate = ('0' + date.getDate()).slice(-2)
      const result = year + '.' + month + '.' + sdate
      return result
    }
  },
  data () {
    return {
      topList: [],
      trendsList: [],

      articleTypeId: 0,
      pageList: [],
      pageIndex: 1,
      pageSize: 5,
      total: 0,
      maxPageIndex: 1,

      area: this.$store.state.area,

      id: this.$route.query.columnId,
      lan: this.$store.state.isEn
    }
  },
  watch: {
    pageIndex (val, oldval) {
      if (val !== oldval) {
        this.init()
      }
    },
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      if (this.pageIndex !== 1) {
        this.pageIndex = 1
      } else {
        this.init()
      }
      this.inittop()
    },
    '$store.state.area' () {
      this.area = this.$store.state.area
      if (this.pageIndex !== 1) {
        this.pageIndex = 1
      } else {
        this.init()
      }
    }
  },
  mounted () {
    localStorage.removeItem('path')
    localStorage.removeItem('columnId')

    if (this.area === 0) {
      this.$api.post('api/benefitArticleType/queryByParam', { parentId: parseInt(this.$route.query.columnId), isDelete: 0 }, r => {
        this.area = r.data[0].id
        this.$store.commit('changeArea', r.data[0].id)
      })
    }
    // this.inittop()
    this.init()
  },
  activated () {
    this.initSwiper()
  },
  methods: {
    inittop () {
      const self = this
      self.topList = []
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeParentId: self.id, current: 1, pageSize: 20, tag: 'true', bLanguage: this.lan }, r => {
        self.topList = r.data
        self.$nextTick(function () {
          self.initSwiper()
        })
      })
    },
    init () {
      const self = this
      self.trendsList = []
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: self.area, current: self.pageIndex, pageSize: self.pageSize, bLanguage: this.lan }, r => {
        self.total = r.total
        if (r.total > 0) {
          self.trendsList = r.data
        }
        self.initPager()
      })
      self.$nextTick(function () {
        self.initEL()
      })
    },
    initPager () {
      const self = this
      const footerCount = 5
      self.pageList = []
      if (self.total > 0) {
        self.maxPageIndex = parseInt(self.total / self.pageSize) + (self.total % self.pageSize === 0 ? 0 : 1)
        let startPageIndex = self.pageIndex - parseInt(footerCount / 2)
        startPageIndex = startPageIndex < 1 ? 1 : startPageIndex
        for (let i = startPageIndex; i <= self.maxPageIndex; i++) {
          self.pageList.push(i)
          if (self.pageList.length >= footerCount) break
        }
      } else {
        self.pageList.push(1)
      }
    },
    initEL () {},
    initSwiper () {
      /* eslint-disable no-new */
      new Swiper('.swiper-container', {
        pagination: '.swiper-pagination',
        slidesPerView: 3,
        slidesPerGroup: 3,
        loop: true,
        autoplay: 3000,
        speed: 1000,
        paginationClickable: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          480: {
            slidesPerView: 1,
            slidesPerGroup: 1
          }
        }
      })
    },
    goDetail (item) {
      const index = this.$route.path.lastIndexOf('/')
      localStorage.setItem('path', this.$route.path.substring(index + 1, this.$route.path.length))
      localStorage.setItem('columnId', this.$route.query.columnId)
      this.$router.push({
        path: '/latesttrends/detail',
        query: {
          columnId: this.$route.query.columnId,
          articleTypeId: item.articleTypeId,
          id: item.id
        }
      })
    }
  }
}
</script>
<style>
.trends{padding: 0 0 5%;}
.trends .top{background-color: #f8f8f8; margin-top: -100px; padding-top: 100px;}
.trends .ul1{margin: 0 -10px;}
.trends .ul1 > div{padding: 0 12px; width: 33.3333%; margin: 3% 0 7%; box-sizing: border-box; cursor: pointer;}
.trends .ul1 .pic{width: 100%; padding-top: 63.41%; position: relative; background-repeat: no-repeat; background-position: center; background-size: cover;}
.trends .ul1 .pic span{position: absolute; left: 0; top: 0; background: url(../../assets/label.png)no-repeat left center; color: #fff; padding-left: 4%; font-size: 20px; width: 149px; line-height: 45px;}
.trends .ul1 .content{background-color: #fff; padding: 8%; min-height: 240px;}
.trends .ul1 .title{font-size: 20px; color: #333; line-height: 1.5; min-height: 60px;}
.trends .ul1 .intro{font-size: 16px; color: #666; font-weight: lighter; line-height: 1.8; padding-top: 3%; word-break: break-word;}
.trends .ul1 .under{padding-top: 8%;}
.trends .ul1 .date{float: left; font-size: 16px; color: #999; font-weight: lighter;}
.trends .ul1 .more{float: right; font-size: 16px; color: #e4007f; font-weight: lighter; background: url(../../assets/a_next.png)no-repeat right center; padding-right: 15px;}
.trends .swiper-pagination{width: 100%; bottom: 3%!important;}
.trends .swiper-pagination span{margin: auto 6px!important;background: #e4007d9a!important;}
.trends .swiper-pagination-bullet-active{background: #e4007f!important;}

.trends .ul2{margin: 3% 0;}
.trends .ul2 li{padding: 4% 0; border-bottom: 1px solid #eee; box-sizing: border-box; cursor: pointer;}
.trends .ul2 li:first-child{padding-top: 0;}
.trends .ul2 .pic{display: inline-block; vertical-align: top; width: 27.35%;}
.trends .ul2 .pic img{max-width: 350px; max-height: 220px; width: 100%;}
.trends .ul2 .content{display: inline-block; padding: 2% 0 0 6%; box-sizing: border-box; width: 72.65%;}
.trends .ul2 .title{font-size: 20px; color: #333; padding-bottom: 3%;}
.trends .ul2 .intro{font-size: 16px; color: #666; line-height: 1.8; word-break: break-word;}
.trends .ul2 .under{padding-top: 6%;}
.trends .ul2 .date{float: left; font-size: 16px; color: #999; font-weight: lighter;}
.trends .ul2 .more{float: right; font-size: 16px; color: #e4007f; font-weight: lighter; background: url(../../assets/a_next.png)no-repeat right center; padding-right: 15px;}
@media(max-width: 768px){
  .trends .ul1 > div{width: 50%;}
}
@media(max-width: 640px){
  .trends .ul2 .pic{width: 100%;}
  .trends .ul2 .pic img{max-width: none; max-height: none;}
  .trends .ul2 .content{width: 100%; padding-left: 0;}
}
@media(max-width: 480px){
  .trends .ul1{padding-bottom: 5%;}
  .trends .ul1 > div{width: 100%;}
}
</style>
